export default __webpack_public_path__ + "static/media/orgs.3d043767.svg";